export const scrollbar = `
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #E5E8E1 transparent;

  /* Webkit browsers (Chrome, Safari, Edge) */
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #E5E8E1;
  }
`;

// A higher-contrast variant for scrollbars that sit on a grey page background,
// where the light thumb above is nearly invisible.
export const scrollbarDark = `
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #A8ACA3 transparent;

  /* Webkit browsers (Chrome, Safari, Edge) */
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #A8ACA3;
  }
`;

// Rounded variant used by the asset-triage scroll regions (queue list and detail
// pane), which sit on a light card over a grey page. Kept here rather than beside
// those components so every thin-scrollbar variant lives in one module.
export const scrollbarRounded = `
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #C9CCC4 transparent;

  /* Webkit browsers (Chrome, Safari, Edge) */
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #C9CCC4;
    border-radius: 3px;
  }
`;
